export default __webpack_public_path__ + "static/member1-f7a76438b8ebb3fdf2c510e09dbd620f.png";